import React, { Component, Fragment } from "react";
import AppRoute from "./AppRoute/AppRoute";
import { BrowserRouter } from "react-router-dom";
import "./Assets/CSS/bootstrap.min.css";
import "./Assets/CSS/animate.min.css";
import "./Assets/CSS/placeholder-loading.min.css";
import "./Assets/CSS/global.css";
import localForage from "localforage";
import axios from "axios";
import { VisitorDetailsURL } from "./APIServices/VisitorDetailsRequest";
import AppDownload from "./Components/AppDownload/AppDownload";

class App extends Component {

  componentDidMount() {

    localForage.clear(function (err) { }).then((r) => { });

    const storedVersion = localStorage.getItem('version');

    const currentVersion = '18'; // Replace with your actual version


    if (storedVersion !== currentVersion) {
      localStorage.clear();
      localStorage.setItem('version', currentVersion);
    }

    axios
      .get(VisitorDetailsURL())
      .then((res) => { })
      .catch((err) => { });
  }

  render() {
    return (
      <Fragment>
        <BrowserRouter>
          <AppRoute />
          <AppDownload />

          {/* <Modal show={this.state.showModal} centered>
            <Modal.Body className="pyt5 text-center">
              <strong style={{fontSize: 24}}>Get Our {this.state.OS} App</strong>
              <br />
              <br />
              <a href={this.state.link}>
                <img width={200} src={this.state.OS === 'Android' ? play_store : ""} alt="" />
                <img width={200} src={this.state.OS === 'iOS' ? app_store : ""} alt="" />
              </a>
            </Modal.Body>
            <Modal.Footer>
              
            </Modal.Footer>
          </Modal> */}
        </BrowserRouter>
      </Fragment>
    );
  }
}

export default App;
